import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={SITE.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Scrivici su WhatsApp"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white w-14 h-14 sm:w-16 sm:h-16 rounded-full grid place-items-center shadow-lg hover:scale-110 transition-transform"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#8B4A2B] rounded-full ring-2 ring-[#F5E6C0] animate-pulse"></span>
    </a>
  );
}
